import { atom } from 'jotai';

/** Timestamp (ms) when the studio session started. Set once on mount. */
export const sessionStartTimeAtom = atom<number>(Date.now());

/** JS heap used in MB when the studio session started (Chrome-only, 0 if unavailable). Set once on mount. */
export const sessionStartHeapAtom = atom<number>(0);